import Concrete from './concrete';
import _background from './background';
import {CENTER, INNER_R, FAN_RADIAN, R, LIGHT_R} from './dimension';

import {imgPromises} from './background'

export default (viewport, startAnimation = false, targetRadian = 0, cb = () => console.log('animation complete'), hover) => {
    const layer = new Concrete.Layer();
    _background(viewport,hover);
    viewport.add(layer);
    const scene = layer.scene;
    window.scene = scene;
    const ctx = scene.context;
    let i = 0;
    let ii = 0;
    let a = 3;
    if (startAnimation) {
        imgPromises.then((array) => {

            const imgDatas = [...array]
            const arrowSrc = imgDatas.pop();


            const mainloop = () => {

                const cx = CENTER[0],
                    cy = CENTER[1];
                /*speed control*/
                ii += 1;
                /*first PI*/
                if (i < 10) {
                    if (ii % 6 === 0) {
                        i += 1
                    }
                } else if (i > targetRadian / FAN_RADIAN - 20 && i < targetRadian / FAN_RADIAN - 7) {
                    if (ii % a === 0) {
                        ii = 0;
                        a += 3;
                        i += 1
                    }
                }
                /*last PI*/
                else if (i >= targetRadian / FAN_RADIAN - 7) {
                    if (ii % a === 0) {
                        ii = 0;
                        a += 10;
                        i += 1
                    }
                } else {
                    if (ii % 3 === 0) {
                        i += 1
                    }
                }


                const _drawFan = (ctx, color, cx, cy, i) => {
                    ctx.beginPath();
                    ctx.moveTo(cx, cy);

                    ctx.arc(
                        cx,
                        cy,
                        R - LIGHT_R - 3,
                        1.5 * Math.PI + i * FAN_RADIAN,
                        1.5 * Math.PI + (i + 1) * FAN_RADIAN
                    );
                    ctx.lineTo(cx, cy);
                    ctx.fillStyle = color;
                    ctx.fill(); // or context.fill()

                    ctx.drawImage(
                        imgDatas[i % 10][0],
                        imgDatas[i % 10][1][0],
                        imgDatas[i % 10][1][1],
                        imgDatas[i % 10][2][0],
                        imgDatas[i % 10][2][1]
                    );

                    /*arrow*/
                    ctx.save()
                    ctx.translate(200, 250);
                    ctx.rotate((288 + i % 10 * 36) * Math.PI / 180);
                    ctx.drawImage(
                        arrowSrc[0],
                        0,
                        -25,
                        60,
                        50
                    );
                    ctx.translate(-200, -250);
                    ctx.restore();


                    //Bigger circle
                    ctx.beginPath();
                    ctx.arc(CENTER[0], CENTER[1], INNER_R, 0, 2 * Math.PI);
                    ctx.fillStyle = 'white';
                    ctx.shadowColor = '#d3d3d3';
                    ctx.shadowBlur = 30;
                    ctx.fill();

                    //Inner circle
                    ctx.beginPath();
                    ctx.arc(CENTER[0], CENTER[1], INNER_R - 3, 0, 2 * Math.PI);
                    ctx.fillStyle = '#034EA2';
                    ctx.fill();


                };

                scene.clear();


                _drawFan(ctx, '#FFFF00 ', cx, cy, i);
                viewport.render();
                if ((i + 1) * FAN_RADIAN < targetRadian) {
                    requestAnimationFrame(mainloop);
                } else {
                    if (cb) {
                        setTimeout(() => {
                            cb();
                        }, 2000);
                    }
                }

            };

            mainloop();

        })
    }
};




